// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VeeValidate, { Validator } from 'vee-validate';
import './validation/unique';
import router from './router';
import store from './store';
import App from './App';
import './styles/vendors/sanitize.css';
import './styles/main.scss';
import messagesDe from '../node_modules/vee-validate/dist/locale/de';

import Default from './layouts/default';
import Simple from './layouts/simple';

function importAll(r) {
  return r.keys().map(r);
}
// impoprt all icons
const icons = importAll(require.context('./assets/icons', false, /\.svg$/));

Vue.component('default', Default);
Vue.component('simple', Simple);

Vue.use(router);
Vue.use(Vuex);

Validator.localize('de', messagesDe);
Vue.use(VeeValidate, {
  fieldsBagName: 'vFields',
  dictionary: {
    de: {
      messages: {
        credentials: 'Falscher Username oder Passwort!',
        requiredSummary: 'Eines oder mehrere Felder sind nicht ausgefüllt.'
      },
      custom: {
        foldername: {
          unique: 'Der Ordnername existiert bereits!'
        },
        prefixName: {
          unique: 'Dieser prefix existiert bereits!'
        }
      }
    },
    en: {
      messages: {
        credentials: 'Wrong user or password',
        requiredSummary: 'All fields are required.'
      },
      custom: {
        foldername: {
          unique: 'This Foldername allready exists!'
        },
        prefixName: {
          unique: 'This prefix allready exists!'
        }
      }
    }
  }
});
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js